import { createContext } from 'react';

// Applied report scope, never the unsubmitted filter-bar edits.
export const ReportExportContext = createContext({ filters: {}, disabled: false });

export function describeReportScope(filters, hierarchy) {
  const fields = [['site_id', 'site_name', 'Site'], ['location_id', 'location_name', 'Location'],
    ['sublocation_id', 'sublocation_name', 'Sublocation'], ['station', 'station_name', 'Screen']];
  return [...fields.map(([key, name, label], index) => {
    if (filters[key] == null || filters[key] === '') return `${label}: All`;
    const row = hierarchy.find(entry => fields.slice(0, index + 1).every(([parent]) =>
      filters[parent] == null || filters[parent] === '' || String(entry[parent === 'station' ? 'station_id' : parent]) === String(filters[parent])));
    return `${label}: ${row?.[name] || 'Name unavailable'}`;
  }), `Meal period: ${filters.daypart || 'All'}`].join(' | ');
}
